<template>
  <v-app id="mainapp-container">
    <component v-bind:is="layout()"></component>
  </v-app>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class App extends Vue {
  layout() {
    return (this.$route && this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : "app") + "-layout"
  }
}
</script>

<style lang="scss">
.data-item {
  display: flex;
  .label {
    font-size: 12px;
    text-transform: uppercase;
  }
  .label::after {
    content: " :";
  }
  .value {
    font-size: 12px;
    font-weight: bold;
    margin-left: 5px;
  }
}
.no-wrap {
  white-space: nowrap;
}
.para {
  white-space: pre-line;
}
.margin-right-nav {
  margin-right: 36px;
}
.pointer {
  cursor: pointer;
}
.v-label {
  font-size: 14px !important;
}
.flat-expanssion-panel {
  margin: 0px 0px 1px 0px;
}
.flat-expanssion-panel .v-expansion-panel-content__wrap {
  padding: 0px !important;
  margin: 0px;
}
.flat-expanssion-panel .v-expansion-panel-header {
  padding: 0px 16px !important;
  margin: 0px;
  font-size: 14px !important;
  font-weight: bold !important;
  border: 1px solid red !important;
  line-height: 2;
}
.list-plot-lists {
  padding-left: 16px !important;
  list-style-type: square;
}
.tooltip-box-content {
  pointer-events: auto;
  padding: 1rem !important;
  opacity: 1 !important;
  color: black !important;
  background-color: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-size: 12px;
  max-width: 360px;
  margin-left: -10px;
}
.v-expansion-panel-header .tooltip-box-content {
  margin-left: 55px !important;
}
.v-text-field__suffix {
  color: silver;
}
.v-text-field--rounded > .v-input__control > .v-input__slot {
  padding: 0px 12px !important;
  font-size: 14px !important;
}
</style>
